
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Alliteams.css";
import Ordercart from "./Ordercart";
import Coppen from "./Coppen";
import axios from "axios";
import DefaultImage from "../menu1.jpg";
import { useParams } from "react-router-dom";
import { useLoader } from "././Context/LoaderProvider.jsx";
import SidescrollAdvertisements from "./SidescrollAdvertisements";

const Cartsdata = () => {
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [refresh, setRefresh] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true); // ✅ Track first load
    const { showLoader, hideLoader } = useLoader();
    const [isFirstFetch, setIsFirstFetch] = useState(true); // ✅ Track first fetch within effect   
    const isMobile = window.innerWidth <= 768;
     const vendorId = Number(localStorage.getItem("vendorId") || 42);

    // Create axios instance with CORRECT baseURL
    const axiosInstance = axios.create({
        baseURL: 'http://testing.maamaas.com:8080',
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    // Add request interceptor for auth token
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('authToken');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const handleCategoryClick = (category) => {
        setActiveCategory(category);
        setTimeout(() => setRefresh((p) => !p), 0);
    };

    useEffect(() => {
        let selected =
            activeCategory === "Allcarts"
                ? cartData
                : cartData.filter((i) => i.dishName === activeCategory);
        setFilteredItems(selected);
    }, [activeCategory, cartData, refresh]);

    useEffect(() => {
        let isMounted = true;
        let intervalId = null;
        let isFirstFetch = true; // ✅ Track first fetch within this effect

        const fetchCartData = async () => {
            const userId = localStorage.getItem("userId");
            const token = localStorage.getItem("authToken");
            
            if (!userId || !token) {
                if (isMounted && isFirstFetch) {
                    hideLoader(); // ✅ Hide loader if no user
                    setIsFirstLoad(false);
                }
                return;
            }

            try {
                const response = await axiosInstance.get(
                    `/food/api/cart/get/user/without-seating?userId=${userId}`
                );
                
                if (isMounted) {
                    console.log("API Response:", response.data);
                    
                    let items = [];
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        items = response.data[0]?.cartItems || [];
                    } else if (response.data.cartItems) {
                        items = response.data.cartItems;
                    } else if (Array.isArray(response.data)) {
                        items = response.data;
                    }
                    
                    setCartData(items);
                    
                    const categories = [...new Set(items.map((i) => i.dishName))];
                    setAllCategories(["Allcarts", ...categories]);
                    setFilteredItems(items);
                }
            } catch (error) {
                console.error("Cart Fetch Error:", error);
                if (error.response) {
                    console.log("Server responded with:", error.response.status);
                }
            } finally {
                // ✅ Hide loader only on first fetch
                if (isMounted && isFirstFetch) {
                    hideLoader();
                    setIsFirstFetch(false);
                    setIsFirstLoad(false);
                }
            }
        };

        // ✅ Show loader only on first load
        if (isFirstLoad) {
            showLoader();
        }
        
        fetchCartData();
        
        // ✅ Set interval for subsequent fetches (without loader)
        intervalId = setInterval(() => {
            fetchCartData();
        }, 8000);

        return () => {
            isMounted = false;
            if (intervalId) clearInterval(intervalId);
        };
    }, []); // Empty dependency array - runs once on mount

    return (
        <>
            <div className="container-fluid" style={{ padding: 0 }}>
                <div className="row" style={{ marginTop: "10px" }}>
                    {/* LEFT SIDEBAR */}
                    <div className="col-lg-2 col-md-3 col-sm-4 col-12">
                        <div
                            className="cart-breadcrumb"
                            style={{
                                position: "sticky",
                                top: "0px",
                                zIndex: 999,
                                background: "#fff",
                                padding: "12px 5px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginTop: "40px",
                            }}
                        >
                            <Link to="/" style={{ color: "#ee6521" }}>
                                Home
                            </Link>
                            <span> &gt; </span>
                             <Link
                                to={`/Newmenuiteam/${vendorId}`}
                                style={{ color: "#ee6521" }}
                            >
                                
                                Menu
                            </Link>
                            <span> &gt; </span>
                            <span style={{ color: "#ee6521", fontWeight: "bold" }}>
                                Cart
                            </span>
                        </div>

                        <div
                            className="category-sidebar"
                            style={{
                                display: isMobile ? "none" : "block",
                                position: "sticky",
                                top: "60px",
                                overflowY: "auto",
                                height: "82vh",
                                paddingRight: "5px",
                                marginTop: "-7px",
                            }}
                        >
                            <div className="sidebar-category-container">
                                {allCategories.map((cat, index) => {
                                    const img =
                                        cat === "Allcarts"
                                            ? DefaultImage
                                            : cartData.find((i) => i.dishName === cat)?.dishImage ||
                                            DefaultImage;
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => handleCategoryClick(cat)}
                                            style={{
                                                backgroundColor:
                                                    activeCategory === cat ? "#ee6521" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                borderRadius: "15px",
                                                cursor: "pointer",
                                                transition: "0.3s",
                                                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                            }}
                                        >
                                            <img
                                                src={img}
                                                alt={cat}
                                                style={{
                                                    width: "80px",
                                                    height: "80px",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                                onError={(e) => {
                                                    e.target.src = DefaultImage;
                                                }}
                                            />
                                            <button
                                                style={{
                                                    backgroundColor:
                                                        activeCategory === cat ? "#ddd" : "#fff",
                                                    border: "none",
                                                    borderRadius: "10px",
                                                    padding: "6px 10px",
                                                    marginTop: "8px",
                                                }}
                                            >
                                                {cat}
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* MAIN CART CONTENT */}
                    <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                        <div
                            style={{
                                marginTop: isMobile ? "0px" : "70px",
                                padding: "10px",
                                overflowX: "hidden",
                                height: "100vh",
                                scrollbarWidth: "none"
                            }}
                        >
                            <Ordercart filteredDataProp={filteredItems} key={activeCategory} />
                        </div>
                    </div>

                    {/* RIGHT ADS */}
                    <div className="col-lg-3 d-none d-lg-block">
    <div style={{ 
        position: "sticky", 
        top: "110px", 
        height: "630px",
        width: "360px",
        marginBottom: "87px" // 👈 neeche ka gap (increase kar sakte ho)
    }}>
        <SidescrollAdvertisements />
    </div>
</div>
                </div>
            </div>
        </>
    );
};

export default Cartsdata;